import { render, staticRenderFns } from "./ChannelMediaTypeCategories.vue?vue&type=template&id=81085af8&scoped=true&"
import script from "./ChannelMediaTypeCategories.vue?vue&type=script&lang=js&"
export * from "./ChannelMediaTypeCategories.vue?vue&type=script&lang=js&"
import style0 from "./ChannelMediaTypeCategories.vue?vue&type=style&index=0&id=81085af8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81085af8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ChannelsCategoriesListItem: require('/opt/render/project/src/channels2022/src/components/channels/ChannelsCategoriesListItem.vue').default})
